import React from 'react';
import './ProgressBar.scss';

const ProgressBar: React.FC<{ label: string; value: number; max: number }> = ({
  label,
  value,
  max,
}) => {
  const baseProgress = Math.min((value / max) * 100, 100);
  const overachievementProgress = value > max ? Math.min(((value - max) / max) * 100, 100) : 0;
  const isGoalReached = value >= max;

  return (
    <div className="progress-section">
      <div className="progress-section-header">
        <span className="progress-label">{label}</span>
        <span className="progress-value">
          <span className="progress-value-number">{value}</span>/{max}
        </span>
      </div>
      <div className="progress-bar">
        <div
          className="progress-fill progress-fill-base"
          style={{ width: `${baseProgress}%` }}
        ></div>
        {isGoalReached && (
          <div
            className="progress-fill progress-fill-overachievement"
            style={{ width: `${overachievementProgress}%` }}
          ></div>
        )}
      </div>
    </div>
  );
};

export { ProgressBar };
